import { Button } from 'antd';
import styled, { css, keyframes } from 'styled-components';

const pulse = keyframes`
0% {
    box-shadow: 0 0 0 0 var(--pulse-color);
  }
  70% {
      box-shadow: 0 0 0 10px transparent;
  }
  100% {
      box-shadow: 0 0 0 0 transparent;
  }
`;

export const PulseButton = styled(({ viewingProgress: _viewingProgress, ...rest }) => (
  <Button {...rest} />
))`
  --pulse-color: color-mix(in srgb, ${({ theme }) => theme.teal} 40%, transparent);
  border: none;
  box-shadow: none;
  animation: ${({ viewingProgress }) =>
    viewingProgress
      ? 'none'
      : css`
          ${pulse} 2s infinite;
        `};
  margin-top: 1.25rem;
  &:hover {
    animation: none;
  }
  svg {
    height: 1.25rem;
    width: 1.25rem;
  }
`;
